import { render, staticRenderFns } from "./alert-integration-required.vue?vue&type=template&id=749c35aa&scoped=true&"
import script from "./alert-integration-required.vue?vue&type=script&lang=js&"
export * from "./alert-integration-required.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749c35aa",
  null
  
)

export default component.exports